import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    async getMedicalNoteTemplateCategory(encodedId) {
        let res = await Axios.get(
            `${baseURL}account/template/medical-note/${encodedId}`,
            {
                params: { encoded: true }
            }
        );

        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async reorderMedicalNoteTemplate(medicalNoteId, params) {
        let res = await Axios.post(
            `${baseURL}account/template/medical-note/content-reorder/${medicalNoteId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async saveMedicalNoteTemplate(medicalNoteId, params) {
        let res = await Axios.post(
            `${baseURL}account/template/medical-note/save-template/${medicalNoteId}`,
            params
        );

        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    }
};
